/* eslint-disable no-shadow */
export var POST_REACTION_TYPES;
(function (POST_REACTION_TYPES) {
    POST_REACTION_TYPES["HAPPY"] = "happy";
    POST_REACTION_TYPES["NEUTRAL"] = "neutral";
    POST_REACTION_TYPES["SAD"] = "sad";
})(POST_REACTION_TYPES || (POST_REACTION_TYPES = {}));
export const reactionMap = {
    happy: POST_REACTION_TYPES.HAPPY,
    neutral: POST_REACTION_TYPES.NEUTRAL,
    sad: POST_REACTION_TYPES.SAD
};
